import React from 'react';
import { makeStyles, Card, CardContent, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Filters } from 'src/components/charts/components';
import { IFiltersCard } from './types';

const useStyles = makeStyles(() => ({
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
    },
}));

export const FiltersCard = ({
    currents,
    setCurrents,
    loadInformation,
}: IFiltersCard) => {
    const classes = useStyles();

    const { t } = useTranslation();

    return (
        <Card elevation={0}>
            <CardContent className={classes.content}>
                <Typography variant="h3">{t('Charts.Filters')}</Typography>
                <Filters
                    currents={currents}
                    setCurrents={setCurrents}
                    loadInformation={loadInformation}
                    buttonProps={{
                        style: {
                            width: 'calc(50% - 10px)',
                        },
                        fullWidth: true,
                    }}
                    disableDateFilter
                />
            </CardContent>
        </Card>
    );
};
